export default {
      id: "Icon--exoticNaturalized-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--exoticNaturalized",
      toString: function () {
        return this.url;
      }
    }